<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">The seller isn’t responding</h1>
			<p>
				Please review the <a :href="`/account/new_messages.php?action=thread&type=postsale&item_id=${parseInt($route.params.id)}#lastmessage`">buyer /
				seller communication tool</a> to make sure you didn't miss any messages from the seller.
			</p>

		<email-form
				subject="The seller isn`t responding"
				:body="email_body"
				on-success-url="/help?#/submitted"
				edit-body
				class="h-email"
				:payload="{ order_line_id }"
				destination-key="cs"
		></email-form>


		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';
	import EmailForm from './../../components/EmailForm';

	export default {
		name: "SellerNotResponding",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				order_line_id: null,
			};
		},

		computed: {
			email_body() {
				return `My Marketplace item had an issue, which I reported to the seller. The seller has not responded.`
			},
		},

		mounted() {
			this.order_line_id = parseInt(this.$route.params.id);
		}
	}
</script>

<style scoped lang="less">
	.h-email {
		margin-top: 10px;
	}
</style>